import { useContent, useLang } from "@/context/AppContext";
import { SectionHeader, Reveal } from "@/components/ui-bits";

// Experience — magazine career spread. NOTE: work periods are NOT published on
// ryanwork.online, so entries render without dates (no invented periods).
export default function Experience() {
  const { t, L } = useLang();
  const { content } = useContent();
  const experiences = content?.experiences || [];

  if (!experiences.length) return null;

  return (
    <section id="experience" className="bg-obsidian py-20 lg:py-32" data-testid="experience-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <SectionHeader eyebrow={t("expEyebrow")} title={t("expTitle")} index={5} />
        <div className="mt-12 border-t border-hairline">
          {experiences.map((exp, i) => (
            <Reveal key={exp.id} delay={i * 0.08}>
              <div className="grid grid-cols-1 gap-6 border-b border-hairline py-10 sm:grid-cols-12 lg:px-6" data-testid={`experience-item-${exp.id}`}>
                <div className="sm:col-span-4">
                  {L(exp.period) ? (
                    <p className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-vermilion">{L(exp.period)}</p>
                  ) : null}
                  <p className="mt-1 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-sand">{exp.company}</p>
                </div>
                <div className="sm:col-span-8">
                  <h3 className="font-display text-2xl font-medium tracking-tight text-bone sm:text-[28px]">{L(exp.role)}</h3>
                  <div className="mt-5 space-y-2.5">
                    {L(exp.responsibilities)
                      .split("·")
                      .map((r, j) =>
                        r.trim() ? (
                          <p key={j} className="flex items-start gap-3 text-[15px] leading-relaxed text-sand">
                            <span className="mt-[9px] h-1 w-4 shrink-0 bg-vermilion/70" />
                            {r.trim()}
                          </p>
                        ) : null
                      )}
                  </div>
                  {L(exp.achievements) ? (
                    <p className="mt-6 border-l-2 border-vermilion pl-4 font-display text-lg font-light italic leading-relaxed text-bone">
                      {L(exp.achievements)}
                    </p>
                  ) : null}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
